import moment from "moment";

// Format epoch millis to YYYY-MM-DD; return '-' for nullish
export const formatEpochDate = (epoch) => {
  if (epoch === null || epoch === undefined) return "-";
  const d = moment(epoch);
  if (!d.isValid()) return "-";
  return d.utc().format("YYYY-MM-DD");
};

// Ensure display placeholder for null/undefined
export const displayOrDash = (v) => (v === null || v === undefined || v === "" ? "-" : v);

// Flatten EMI details per spec to a row with 6 EMI steps
export const flattenEmiDetails = (items = []) => {
  if (!Array.isArray(items)) return [];
  return items
    .filter((it) => (it?.paymentTerms ?? 0) > 0) // safeguard if backend slips through
    .map((dto) => {
      const base = {
        invoiceNo: dto.invoiceNo ?? null,
        invoiceDate: dto.invoiceDate ?? null,
        serialNumber: dto.serialNumber ?? null,
        itemName: dto.itemName ?? null,
        paymentTerms: dto.paymentTerms ?? null,
        salesAgentCode: dto.salesAgentCode ?? null,
        knoxStatus: dto.knoxStatus ?? null,
        daysOverdue: dto.daysOverdue ?? 0,
      };

      const steps = Array.from({ length: 6 }, (_, idx) => ({
        dueDate: null,
        expected: null,
        paid: null,
        paidDate: null,
        status: null,
      }));

      const emis = Array.isArray(dto.emis) ? dto.emis.slice().sort((a, b) => a.stepNumber - b.stepNumber) : [];
      emis.slice(0, 6).forEach((step) => {
        const pos = Math.max(1, Math.min(6, step.stepNumber));
        steps[pos - 1] = {
          dueDate: step.dueDate ?? null,
          expected: step.expectedAmount ?? null,
          paid: step.paymentAmount ?? null,
          paidDate: step.paymentDate ?? null,
          status: step.status ?? null,
        };
      });

      const flattened = { ...base };
      steps.forEach((s, i) => {
        const k = i + 1;
        flattened[`emi${k}_dueDate`] = s.dueDate;
        flattened[`emi${k}_expected`] = s.expected;
        flattened[`emi${k}_paid`] = s.paid;
        flattened[`emi${k}_paidDate`] = s.paidDate;
        flattened[`emi${k}_status`] = s.status;
      });

      return flattened;
    });
};

